import { ChevronLeft, ChevronRight } from "lucide-react";

const SIZES = [25, 50, 100, "all"];

// Compact pagination bar: "Showing X–Y of Z", page-size chips, and Prev/Next.
export function Pagination({ page, setPage, pageSize, setPageSize, total, size, pageCount, startIdx, testId = "pagination" }) {
  if (!total) return null;
  return (
    <div data-testid={testId} className="flex flex-wrap items-center justify-between gap-3 py-2 text-xs text-[#68665E]">
      <span>
        Showing <span className="font-semibold text-[#1A1A18]">{startIdx + 1}–{Math.min(startIdx + size, total)}</span> of{" "}
        <span className="font-semibold text-[#1A1A18]">{total}</span>
      </span>
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-1">
          <span className="hidden sm:inline mr-1">Show</span>
          {SIZES.map((s) => (
            <button key={s} onClick={() => setPageSize(s)} data-testid={`${testId}-size-${s}`}
              className={`px-2 py-0.5 rounded-full border text-[11px] transition-colors ${pageSize === s ? "bg-[#1A1A18] text-white border-[#1A1A18]" : "border-[#E5E3DB] hover:bg-[#F5F3EC]"}`}>
              {s === "all" ? "All" : s}
            </button>
          ))}
        </div>
        {pageSize !== "all" && pageCount > 1 && (
          <div className="flex items-center gap-1">
            <button disabled={page === 0} onClick={() => setPage((p) => Math.max(0, p - 1))} data-testid={`${testId}-prev`}
              className="inline-flex items-center gap-1 px-2 py-1 rounded border border-[#E5E3DB] disabled:opacity-40 hover:bg-[#F5F3EC]">
              <ChevronLeft className="w-3 h-3" /> Prev
            </button>
            <span className="px-1 tabular-nums">{page + 1}/{pageCount}</span>
            <button disabled={page + 1 >= pageCount} onClick={() => setPage((p) => Math.min(pageCount - 1, p + 1))} data-testid={`${testId}-next`}
              className="inline-flex items-center gap-1 px-2 py-1 rounded border border-[#E5E3DB] disabled:opacity-40 hover:bg-[#F5F3EC]">
              Next <ChevronRight className="w-3 h-3" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
